import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';

const PipelineStatusBadge = ({ status }) => {
  const stageObject = PIPELINE_STATUS_OPTIONS.find((stage) => stage.value === status);
  return (
    <div className={`fw-bold bg-gray-900 text-gradient-${stageObject.variant}-white`}>
      {stageObject.label}
    </div>
  );
};

export default PipelineStatusBadge;
